import React from "react";
import { Link } from "react-router-dom";
import {
  Home,
  ClipboardList,
  UserCircle2,
  CalendarCheck2,
  Briefcase,
} from "lucide-react";
import SharedDashboardLayout from "../layout/shared-dashboard-layout";
import { useHandymanOnboardingStatus } from "../../hooks/use-handyman-onboarding-status";

const BASE_LINKS = [
  { title: "Dashboard", icon: Home, href: "/handyman/dashboard" },
  { title: "New Requests", icon: ClipboardList, href: "/handyman/tasks" },
  { title: "My Jobs", icon: Briefcase, href: "/handyman/my-jobs" },
  { title: "Schedule", icon: CalendarCheck2, href: "/handyman/schedule" },
];

const Layout = () => {
  const onboardingCompleted = useHandymanOnboardingStatus();

  const sidebarLinks = BASE_LINKS.map(link => ({
    ...link,
    disabled: !onboardingCompleted && link.href !== "/handyman/dashboard"
  }));

  return (
    <SharedDashboardLayout 
      sidebarLinks={sidebarLinks}
      defaultRole="handyman"
    />
  );
};

export default Layout;
